import { useEffect, useState } from "react";
import { Card, Avatar, Divider, Empty, Button, message } from "antd";
import { PlusOutlined, ToolOutlined } from "@ant-design/icons";

import BlueButton from "../../components/shared/BlueButton";
import SearchAndCreateEquipmentModal from "../equipment/SearchAndCreateEquipmentModal";
import RemoveItemModal from "../shared/RemoveModal";

import { getFileUrl } from "../../api/file";
import { createEquipment } from "../../api/equipment";
import { UserRole } from "../../lib/constants";

export default function ProjectEquipments({ project, afterClose, user }) {
    const [isEquipmentModalOpen, setIsEquipmentModalOpen] = useState(false);
    const [isDisabled, setIsDisabled] = useState(true);

    const onEquipmentSubmit = async ({
        name,
        nickName,
        status,
        type,
        rate,
        rateBy,
        description,
    }) => {
        const data = {
            name,
            nickName,
            status,
            type,
            rate: {
                rate,
                rateBy,
            },
            description,
        };
        createEquipment(data).then(() => {
            setIsEquipmentModalOpen(false);
            message.success("Equipment created successfully")
        });
    };

    useEffect(() => {
        if (project) {
            setIsDisabled(false)
        }
    }, [project])


    return (
        <Card
            title={<p className="font-medium">Equipments on this Project</p>}
            extra={
                user?.role !== UserRole.AccountManager && (
                    <BlueButton
                        type="default"
                        className="flex items-center rounded-none"
                        onClick={() => setIsEquipmentModalOpen(true)}
                        disabled={isDisabled}
                    >
                        <PlusOutlined /> Add Equipiment to Project
                    </BlueButton>
                )
            }
            className="w-full rounded-none"
        >
            {
                isDisabled ? <EmptyState /> :
                    project.projectEquipments &&
                        project.projectEquipments.length > 0 &&
                        project.projectEquipments.some((projectEquipment) => projectEquipment.isActive) ? (
                        project.projectEquipments.map((projectEquipment) => {
                            if (projectEquipment.isActive) {
                                return (
                                    <div className="flex flex-col justify-start p-4" key={projectEquipment.id}>
                                        <div className="w-full pb-2 flex items-center justify-between">
                                            <div className="flex space-x-4 items-center">
                                                <Avatar
                                                    src={
                                                        projectEquipment.equipment?.avatars?.length > 0
                                                            ? getFileUrl(projectEquipment.equipment.avatars[0])
                                                            : undefined
                                                    }
                                                    icon={<ToolOutlined />}
                                                />
                                                <div>
                                                    <p className="">{projectEquipment.equipment.name}</p>
                                                    <p className="text-sm text-gray-500">
                                                        {projectEquipment.equipment.nickName}
                                                    </p>
                                                </div>
                                            </div>
                                            {user?.role !== UserRole.AccountManager && (
                                                <Button type="link"
                                                    onClick={() =>
                                                        RemoveItemModal({
                                                            type: "projectEquipment",
                                                            id: projectEquipment.id,
                                                            refresh: () => afterClose(),
                                                        })
                                                    }
                                                >Remove
                                                </Button>
                                            )}
                                        </div>
                                        <Divider className="p-0 m-0" />
                                    </div>
                                );
                            } else return null;
                        })
                    ) : (
                        <EmptyState />
                    )}
            {
                !isDisabled && user?.role !== UserRole.AccountManager &&
                < SearchAndCreateEquipmentModal
                    isModalOpen={isEquipmentModalOpen}
                    handleOk={onEquipmentSubmit}
                    handleCancel={() => setIsEquipmentModalOpen(false)}
                    project={project}
                    afterClose={afterClose}
                />}
        </Card>
    )
}

const EmptyState = () => {
    return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} className="my-8" />
}
